import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export const DeleteBarDialog = ({ barIdx, onConfirm, onCancel }) => (
  <AlertDialog open={barIdx !== null} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent data-testid="seq-delete-dialog" className="bg-[#111112] border-white/10 text-white">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-bebas text-3xl tracking-wide">Eliminare la battuta {barIdx !== null ? barIdx + 1 : ''}?</AlertDialogTitle>
        <AlertDialogDescription className="text-white/55">Le battute successive scorreranno in su.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="seq-delete-cancel" className="bg-transparent border-white/15 text-white hover:bg-white/5 hover:text-white">Annulla</AlertDialogCancel>
        <AlertDialogAction data-testid="seq-delete-confirm" onClick={onConfirm} className="bg-rose-500 text-white hover:bg-rose-400">Elimina</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
